/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function Cooperative() {
  const dispatch = useDispatch();
  const [cooperative, setCooperative] = useState<any>([]);

  useEffect(() => {
    getBannerCompanies();
  }, []);

  // 교육기관 배너 가져오기
  const getBannerCompanies = async () => {
    await server
      .getBannerFlag(1, 100, 1)
      .then(async (payload) => {
        setCooperative(payload.items);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  const cooperativeRow = cooperative.map((item: any) => (
    <a href={item.siteUrl} target="_blank" key={item.id}>
      <div className="image">
        <img src={`${process.env.REACT_APP_API_URL}/public${item.imageUrl}`} alt="" />
      </div>
      <span>{item.college}</span>
    </a>
  ));

  return (
    <main className="sub bookstore wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>고객센터</>
          {' > '}
          <>협력사 안내</>
        </div>
        <div className="title">
          <h2>협력사 안내</h2>
          <p>도서출판 구민사의 서적과 함께하는 협력사 안내입니다.</p>
        </div>
        <section>
          <div className="links">{cooperativeRow}</div>
        </section>
      </div>
    </main>
  );
}
